// extracted by mini-css-extract-plugin
module.exports = {"description":"TaskDescription-module__description--2a4WW"};